import { render, staticRenderFns } from "./ProfileActivity.vue?vue&type=template&id=6cace810&scoped=true&"
import script from "./ProfileActivity.vue?vue&type=script&lang=js&"
export * from "./ProfileActivity.vue?vue&type=script&lang=js&"
import style0 from "./ProfileActivity.vue?vue&type=style&index=0&id=6cace810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cace810",
  null
  
)

export default component.exports